import type { SymbolKey } from '@/entities/symbol';
import { symbolKey } from '@/entities/symbol';

import { SELECTOR_MODES } from '../state/symbolSelector.slice';

export function formatSelectionLabel(symbols: SymbolKey[], selectorMode: SELECTOR_MODES): string {
  if (selectorMode === SELECTOR_MODES.FORWARD_CURVE) {
    const n = new Set(symbols.map(s => symbolKey(s, true))).size;
    return `${n} ${n === 1 ? 'curve' : 'curves'} selected`;
  }
  const n = symbols.length;
  return `${n} ${n === 1 ? 'item' : 'items'} selected`;
}
